import { useCallback } from 'react';
import { createMockFetch, NonThrowingFetchWithMocks } from '@cbhq/identity-shared/mocks';

import { MockHandlerConfig } from './types';
import { useMockHandler } from './useMockHandler';

type MockMiddleware = () => NonThrowingFetchWithMocks;

export function useMockMiddleware(
  handlers: MockHandlerConfig,
  pathPrefix?: string,
  projectId?: string,
): MockMiddleware {
  const { getMockResponse } = useMockHandler(handlers, pathPrefix);

  return useCallback(
    () =>
      createMockFetch(getMockResponse, {
        projectId,
      }),
    [getMockResponse, projectId],
  );
}
